// Path: src\Components\Header\Header.jsx
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Diamond from "../../assets/images/diamond.svg";
import Coin from "../../assets/images/coin.png";

import { useProfileDataContext } from "../ProfileContext/ProfileContext";
import { url } from "../../config/url";
import { kFormatter } from "../../Utilities/kFormatter";
import { useNavigate } from "react-router";
import logo from "../../assets/images/Vi4x_logo.png";
import zIndex from "@mui/material/styles/zIndex";
import { hexToRgb } from "@mui/material";
import { height } from "@mui/system";

const Header = ({ title, onBackClick, isWallet, isReward, notBack }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fetchAccountProfile, liteProfile } = useProfileDataContext();

  useEffect(() => {
    if (isWallet || isReward) {
      fetchAccountProfile();
    }
  }, [isWallet, isReward]);

  const getTotalBalance = (code) => {
    let index = liteProfile?.wallet?.findIndex(
      (obj) => obj.currencyData?.code === code
    );
    if (index > -1) {
      return liteProfile?.wallet[index].winningAmount
        ? Math.floor(liteProfile?.wallet[index].winningAmount)
        : 0;
    }
    return 0;
  };

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
      console.log("Back button clicked", onBackClick);
    } else {
      const isHomePage = window.location.pathname === "/home";
      if (isHomePage) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage("CLOSE_WEBVIEW");
        } else if (window.close) {
          window.close();
        } else {
          console.log("Can't close window, going back normally");
          navigate(-1);
        }
      } else {
        navigate(-1);
      }
      console.log(
        "Back button clicked",
        onBackClick,
        isHomePage,
        window.ReactNativeWebView,
        window.close
      );
    }
  };

  return (
    <>
      <div className="header">
        {isWallet ? (
          <div className="row w-100">
            <div className="col-1">
              <div
                className="first backArrow"
                onClick={handleBackClick}
                style={{ zIndex: "9" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8 17L3 12M3 12L8 7M3 12H21"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div className="col-2 main-header-img">
              <img src={logo} alt="img" className="logo" />
            </div>
            <div className="col-3"></div>
            <div className="col-3">
              {liteProfile?.wallet?.find(
                (obj) => obj.currencyData?.code === "VC"
              ) ? (
                <div className="coin-border me-2">
                  {getTotalBalance("VC")}
                  <img
                    className="icon-20 icon-21 me-1"
                    src={
                      url.IMAGE_URL +
                      liteProfile.wallet.find(
                        (obj) => obj.currencyData?.code === "VC"
                      )?.currencyData?.img?.default
                    }
                    alt="VC"
                  />
                </div>
              ) : (
                <div className="coin-border me-2">
                  0
                  <img className="icon-20 icon-21 me-1" src={Coin} alt="VC" />
                </div>
              )}
            </div>
            <div className="col-3">
              {liteProfile?.wallet?.find(
                (obj) => obj.currencyData?.code === "gems"
              ) ? (
                <div className="coin-border">
                  {getTotalBalance("gems")}
                  <img
                    className="icon-20 icon-21"
                    src={
                      url.IMAGE_URL +
                      liteProfile.wallet.find(
                        (obj) => obj.currencyData?.code === "gems"
                      )?.currencyData?.img?.default
                    }
                    alt="gems"
                  />
                </div>
              ) : (
                <div className="coin-border me-2">
                  0
                  <img
                    className="icon-20 icon-21 me-1"
                    src={Diamond}
                    alt="gems"
                  />
                </div>
              )}
            </div>
            {/* <div className="col-6">
                                <div className="row">
                                    <div className="col-3">
                                    </div>
                                    <div className="col-3">
                                        <span style={{
                                            minHeight: "60px",
                                            minWidth: "20%",
                                            maxWidth: "34%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            maxHeight: "45px"
                                        }}>

                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className='d-flex' style={{ paddingTop: "10px" }}>
                                </div>
                            </div> */}
          </div>
        ) : isReward ? (
          <div className="d-flex justify-content-between w-100">
            <div className="reward-store-coinborder">
              <span>{t("rewards-store.rewardStore")}</span>
            </div>
            <div className="d-flex">
              {liteProfile?.wallet?.find(
                (obj) => obj.currencyData?.code === "VC"
              ) ? (
                <div className="coin-border me-2">
                  {getTotalBalance("VC")}
                  <img
                    className="icon-20 icon-21 me-1"
                    src={
                      url.IMAGE_URL +
                      liteProfile.wallet.find(
                        (obj) => obj.currencyData?.code === "VC"
                      )?.currencyData?.img?.default
                    }
                    alt="VC"
                  />
                </div>
              ) : (
                <div className="coin-border me-2">
                  0
                  <img className="icon-20 icon-21 me-1" src={Coin} alt="VC" />
                </div>
              )}
              {liteProfile?.wallet?.find(
                (obj) => obj.currencyData?.code === "gems"
              ) ? (
                <div className="coin-border">
                  {getTotalBalance("gems")}
                  <img
                    className="icon-20 icon-21"
                    src={
                      url.IMAGE_URL +
                      liteProfile.wallet.find(
                        (obj) => obj.currencyData?.code === "gems"
                      )?.currencyData?.img?.default
                    }
                    alt="gems"
                  />
                </div>
              ) : (
                <div className="coin-border me-2">
                  0
                  <img
                    className="icon-20 icon-21 me-1"
                    src={Diamond}
                    alt="gems"
                  />
                </div>
              )}
            </div>
          </div>
        ) : (
          <>
            {!notBack && (
              <div className="first backArrow" onClick={handleBackClick}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M8 17L3 12M3 12L8 7M3 12H21"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            )}
            <div className="second">{title}</div>
          </>
        )}
      </div>

      {/* <div className='header'>
            {
                isWallet ?
                    <div className='d-flex justify-content-between w-100'>
                        <div className='first backArrow' onClick={handleBackClick} style={{ zIndex: "9" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M8 17L3 12M3 12L8 7M3 12H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <span style={{
                            minHeight: "60px",
                            minWidth: "20%",
                            maxWidth: "34%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            maxHeight: "45px"
                        }}>
                            <img
                                src={logo}
                                alt="img"
                                className="logo"
                                style={{
                                    height: "70%", // Adjust height if needed
                                    padding: "0 40px"
                                }}
                            />

                        </span>
                        <div className='d-flex' style={{ paddingTop: "10px"}}>
                            {liteProfile?.wallet?.find(obj => obj.currencyData?.code === "VC") ?
                                <div className='coin-border me-2'>
                                    {getTotalBalance("VC")}
                                    <img className='icon-20 icon-21 me-1' src={url.IMAGE_URL + liteProfile.wallet.find(obj => obj.currencyData?.code === "VC")?.currencyData?.img?.default} alt="VC" />
                                </div>
                                :
                                <div className='coin-border me-2'>
                                    0
                                    <img className='icon-20 icon-21 me-1' src={Coin} alt="VC" />
                                </div>
                            }
                            {liteProfile?.wallet?.find(obj => obj.currencyData?.code === "gems") ?
                                <div className='coin-border'>
                                    {getTotalBalance("gems")}
                                    <img className='icon-20 icon-21' src={url.IMAGE_URL + liteProfile.wallet.find(obj => obj.currencyData?.code === "gems")?.currencyData?.img?.default} alt='gems' />
                                </div>
                                :
                                <div className='coin-border me-2'>
                                    0
                                    <img className='icon-20 icon-21 me-1' src={Diamond} alt="gems" />
                                </div>
                            }
                        </div>
                    </div>
                    :
                    isReward ?
                        <div className="d-flex justify-content-between w-100">
                            <div className='reward-store-coinborder'>
                                <span>{t("rewards-store.rewardStore")}</span>
                            </div>
                            <div className="d-flex">
                                {liteProfile?.wallet?.find(obj => obj.currencyData?.code === "VC") ?
                                    <div className='coin-border me-2'>
                                        {getTotalBalance("VC")}
                                        <img className='icon-20 icon-21 me-1' src={url.IMAGE_URL + liteProfile.wallet.find(obj => obj.currencyData?.code === "VC")?.currencyData?.img?.default} alt="VC" />
                                    </div>
                                    :
                                    <div className='coin-border me-2'>
                                        0
                                        <img className='icon-20 icon-21 me-1' src={Coin} alt="VC" />
                                    </div>
                                }
                                {liteProfile?.wallet?.find(obj => obj.currencyData?.code === "gems") ?
                                    <div className='coin-border'>
                                        {getTotalBalance("gems")}
                                        <img className='icon-20 icon-21' src={url.IMAGE_URL + liteProfile.wallet.find(obj => obj.currencyData?.code === "gems")?.currencyData?.img?.default} alt='gems' />
                                    </div>
                                    :
                                    <div className='coin-border me-2'>
                                        0
                                        <img className='icon-20 icon-21 me-1' src={Diamond} alt="gems" />
                                    </div>
                                }
                            </div>
                        </div>
                        :
                        <>
                            {
                                !notBack &&
                                <div className='first backArrow' onClick={handleBackClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M8 17L3 12M3 12L8 7M3 12H21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            }
                            <div className='second'>
                                {title}
                            </div>
                        </>
            }
        </div> */}
    </>
  );
};

export default Header;
